
import { Injectable, Injector } from '@angular/core';
import { MyAuthService } from '../../authentication/auth.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { Observable } from 'rxjs';
import { throwError as observableThrowError, BehaviorSubject } from 'rxjs';

import { take, filter, catchError, switchMap, finalize, map } from 'rxjs/operators';
import {
    HttpClient, HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent,
    HttpResponse, HttpUserEvent, HttpErrorResponse
} from '@angular/common/http';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    isRefreshingToken = false;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    constructor(private injector: Injector,
        private _route: Router,
        private _auth: MyAuthService,
        private _toast: ToastrService) { }
    addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
        if (token && !req.url.includes('refresh')) {
            return req.clone({ setHeaders: { Authorization: 'Bearer ' + token } });
        } else {
            return req;
        }
    }

    intercept(request: HttpRequest<any>, next: HttpHandler):
        Observable<HttpEvent<any> | HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
        //console.log('requestttt', request);

        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        const loadingContainer: HTMLElement = document.getElementsByClassName('loading').item(0) as HTMLElement;
        loadingContainer.style.display = 'block';
        if (navigator.onLine) {

            return next.handle(this.addToken(request, this._auth.getAuthToken())).pipe(
                map((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        //console.log('event--->>>', event);
                        loadingContainer.style.display = 'none';
                        // this.errorDialogService.openDialog(event);
                        //console.log(event);
                    }
                    return event;
                }),

                catchError(error => {
                    loadingContainer.style.display = 'none';
                    if (!request.url.includes('refresh')) {
                        if (error instanceof HttpErrorResponse) {
                            console.log(error.status);
                            switch ((<HttpErrorResponse>error).status) {
                                case 400:
                                    return this.handle400Error(error);
                                case 422:
                                    return this.handle422Error(error);
                                case 401:
                                    return this.handle401Error(request, next, error);
                                default:
                                    return observableThrowError(error);
                            }
                        } else {
                            return observableThrowError(error);
                        }
                    } else {
                        return observableThrowError(error);
                    }
                }));
        } else {
            loadingContainer.style.display = 'none';
            this._toast.error('No Internet Connection');
            return observableThrowError('');

        }
    }

    handle401Error(req: HttpRequest<any>, next: HttpHandler, error) {
        if (error.status === 401 && ((error.error.msg && error.error.msg === 'Token has expired')
            || (error.error.msg && error.error.msg === 'Token has been revoked'))) {
            //console.log('refresh token', this.isRefreshingToken);
            if (!this.isRefreshingToken) {
                this.isRefreshingToken = true;

                // Reset here so that the following requests wait until the token
                // comes back from the refreshToken call.
                this.tokenSubject.next(null);

                return this._auth.refreshToken().pipe(
                    switchMap((newToken: any) => {
                        if (newToken.access_token) {
                            this.tokenSubject.next(newToken.access_token);
                            return next.handle(this.addToken(req, newToken.access_token));
                        }

                        // If we don't get a new token, we are in trouble so logout.
                        return this.logoutUser();
                    }),
                    catchError(err => {
                        // If there is an exception calling 'refreshToken', bad news so logout.
                        console.log('Refresh Token', err);
                        return this.logoutUser();
                    }),
                    finalize(() => {
                        this.isRefreshingToken = false;
                    }));
            } else {
                return this.tokenSubject.pipe(
                    filter(token => token != null),
                    take(1),
                    switchMap(token => {
                        return next.handle(this.addToken(req, token));
                    }));
            }
        } else if (error.status === 401 && error.statusText === 'UNAUTHORIZED') {
            return this.logoutUser();
        }
    }
    handle400Error(error) {
        if (error && error.status === 400 && error.error && error.error.error === 'UNAUTHORIZED') {
            // If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
            return this.logoutUser();
        }

        return observableThrowError(error);
    }
    handle422Error(error) {
        if (error.status === 422 && error.statusText === 'UNPROCESSABLE ENTITY') {
            // If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
            return this.logoutUser();
        }
        return observableThrowError(error);
    }

    logoutUser() {
        // Route to the login page (implementation up to you)
        return this._auth.logoutUser();
        // return observableThrowError('');
    }
}
